import { Component, EventEmitter, Input, OnInit, Output,SimpleChanges } from '@angular/core';
import { FieldConfig } from '../field.interface';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatError, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultLayoutGapDirective } from '../../../flex-layout/custom-layout-gap';
import { DefaultFlexDirective } from '../../../flex-layout/flex';

@Component({
  selector: 'calsoft-input',
  imports: [DefaultLayoutDirective, DefaultLayoutGapDirective, MatFormField, DefaultFlexDirective, FormsModule, ReactiveFormsModule, MatLabel, MatInput, MatError, MatHint, MatButton],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss'
})
export class InputComponent implements OnInit {
  @Input() field: FieldConfig |any;
  @Input() customField13: any;
  @Input() group: UntypedFormGroup |any;
  @Input() type: any;
  @Output() valueChange = new EventEmitter<any>();
  inputLength: number = 0;
  display: boolean = false;
  resultvalue: boolean = false;
  hover: boolean = false; 
  start:any;

  constructor() { }

 ngOnChanges(changes: SimpleChanges): void {
  if (changes['field'] && changes['field'].currentValue) {
    const control = this.group.get(this.field.name);
    if (control) {
      control.valueChanges.subscribe((value: any) => {
        this.inputLength = value?.length;
      });
    }
  }
}


 

  ngOnInit() {
  
    
    const control = this.group.get(this.field.name);
    if (control) {
      control.valueChanges.subscribe((value :any) => {
        this.inputLength = value?.length;
     //   this.checkCondition();
      });
    }

    if (this.group != undefined) {
      this.display = true;
    }
  }




  isRequired(fieldName: string): boolean {
    const control = this.group.get(fieldName);
    return control && control.hasError('required');
  }



  setValue(value: any) {
    if (this.group.get(this.field.name)?.valid) {
      this.group.get(this.field.name).setValue(value);
      this.valueChange.emit( this.field.name);
    } else {
      console.error('Form control is invalid');
    }
  }
}
